import React from "react";
import { FormContext } from "./FormContext";

export default class Checkbox extends React.Component {
	static contextType = FormContext;

	static id = 1;

	constructor(props) {
		super(props);
		this.state = {
			value: props.value,
			error: false
		};

		this.handleChange = this.handleChange.bind(this);
		this.setValue = this.setValue.bind(this);
		this.setError = this.setError.bind(this);
		this.htmlId = "c" + Checkbox.id++;
	}

	setValue(value) {
		this.setState({ value: value });
	}

	setError(error) {
		this.setState({ error: error });
	}

	handleChange(e) {
		let value = e.target.checked;
		this.setState({ value: value });
		this.context.setValue(this.props.name, value);
		if (this.props.onChange)
			this.props.onChange(value);
	}

	componentDidMount() {
		this.context.initInput(this.props.name, this.props.value, this.setValue, this.setError);
	}

	componentWillUnmount() {
		this.context && this.context.removeInput(this.props.name);
	}

	render() {
		return (
			<div className="form-check">
				<input type="checkbox" checked={this.state.value} onChange={this.handleChange} disabled={this.props.readOnly || this.context.readOnly} className={"form-check-input" + (this.state.error ? " is-invalid" : '')} id={this.htmlId} />
				<label className="form-check-label" htmlFor={this.htmlId}>{this.props.label}</label>
				{this.state.error && <div className="invalid-feedback">{this.state.error}</div>}
			</div>
		);
	}
}